let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("bN0OL")), load("6es7M")]).then(() => parcelRequire('7g6vL'));